export enum ConfirmEmailStep {
  Step1,
  Step2,
}
